import { Box, Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import { HallBookingsBookingSummary } from "./components/HallBookingsBookingSummary";
import { HallBookingsShowTable } from "./components/HallBookingsShowTable";

export const HallBookingsInformationWorkspace = () => (
  <Box>
    <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
      <Grid
        size={{
          xs: 12,
          md: 12,
        }}
      >
        <Card variant="outlined">
          <CardContent sx={{ p: 1.5 }}>
            <Typography variant="h6" sx={{ mb: 0.25 }}>
              Booking overview
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Organizer details, payment summary, and agreed contribution controls.
            </Typography>
            <HallBookingsBookingSummary />
          </CardContent>
        </Card>
      </Grid>
    </Grid>

    <Card variant="outlined">
      <CardContent sx={{ p: 1.5 }}>
        <Typography variant="h6" sx={{ mb: 0.25 }}>
          Hall booking lines
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Manage individual hall slots, event links, and remarks.
        </Typography>
        <Divider sx={{ mb: 1 }} />
        <HallBookingsShowTable />
      </CardContent>
    </Card>
  </Box>
);

export default HallBookingsInformationWorkspace;
